var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { localized, msg, str } from '@lit/localize';
import { getDataFrameFromCSV, getDataFrameFromExcel } from '../../utils/file';
import '../text/BasicNote.js';
let FileTable = class FileTable extends LitElement {
    constructor() {
        super(...arguments);
        this.rowsPerPage = 15;
        this.dataFrame = null;
        /** Why the current file could not be turned into a DataFrame, if it could
         *  not. Rendered in place of the table — a parse failure used to leave an
         *  empty table and no explanation. */
        this.error = null;
    }
    // Load dataframe when the component receives the file
    async updated(changedProperties) {
        if (changedProperties.has('file') && this.file) {
            const fileExtension = this.file.name.split('.').pop()?.toLowerCase();
            // Resolved into locals and assigned once, so a file swap costs a single
            // render rather than one for the reset and one for the result.
            let dataFrame = null;
            let error = null;
            try {
                if (fileExtension === 'csv') {
                    dataFrame = await getDataFrameFromCSV(this.file);
                }
                else if (fileExtension === 'xlsx') {
                    dataFrame = await getDataFrameFromExcel(this.file);
                }
                else if (fileExtension === 'xls') {
                    // The legacy binary format is a different beast from .xlsx and is
                    // not supported; Excel's own "Save as" converts it in one step.
                    error = msg('Legacy .xls files are not supported. Open the file in Excel and save it as .xlsx, then import it again.', { id: 'fileTable.error.legacyXls', desc: 'Error shown when a legacy .xls file is imported' });
                }
                else {
                    error = msg(str `Unsupported file type ".${fileExtension}". Import a .csv or .xlsx file.`, { id: 'fileTable.error.unsupportedType', desc: 'Error shown when an unsupported file type is imported' });
                }
            }
            catch (e) {
                const detail = e?.message ? String(e.message) : '';
                error = msg(str `This file could not be read: ${detail}`, { id: 'fileTable.error.unreadable', desc: 'Error shown when a file cannot be parsed' });
            }
            this.dataFrame = dataFrame;
            this.error = error;
            if (error) {
                console.error('[file-table]', error, this.file.name);
            }
            this.dispatchEvent(new CustomEvent('dataframe-loaded', { detail: this.dataFrame }));
        }
    }
    getDataFrame() {
        return this.dataFrame;
    }
    render() {
        if (this.error) {
            return html `<basic-note variant="danger" size="medium" role="alert">
        ${this.error}
      </basic-note>`;
        }
        return html `
      <basic-table
        .dataFrame=${this.dataFrame}
        .rowsPerPage=${this.rowsPerPage}
      ></basic-table>
    `;
    }
};
__decorate([
    property({ type: Object })
], FileTable.prototype, "file", void 0);
__decorate([
    property({ type: Number })
], FileTable.prototype, "rowsPerPage", void 0);
__decorate([
    state()
], FileTable.prototype, "dataFrame", void 0);
__decorate([
    state()
], FileTable.prototype, "error", void 0);
FileTable = __decorate([
    localized(),
    customElement('file-table')
], FileTable);
export { FileTable };
//# sourceMappingURL=FileTable.js.map